<template>
    <div class="mb-3">
        <div class="container-fluid py-4 banner" >

            <div class="d-flex flex-column">
                <div class="d-flex text-container">
                    <div class="mr-3 ml-lg-2 bannerIcon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="flex-fill">
                        <div>
                            <span class="bannerHeading" v-html="bannerHeader"></span> <br />
                            <span class="bannerText" v-html="bannerText"></span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import './msk.banner.scss';

export default {
    name: 'banner-component',
    props: {
        bannerHeader: { type:String },
        bannerText: { type: String },
        color: {type: String },
        icon: {type: String, default: "fas fa-exclamation-circle" }
    },
    computed: {
        iconCss: function () {
            return "banner-icon fa-fw d-inline-block " + this.icon;
        }
    }
};

</script>